<template>
  <div
    v-if="dndStore.startPageDrag"
    :style="cssProps"
  />
</template>

<script>
import { mapStores } from 'pinia'
// import AwDnd from './AwDnd'
import useDndStore from '@/frontapp/store/dnd'

export default {
  computed: {
    cssProps() {
      return {
        'padding-top': this.dndStore.pageDragPaddingTop + 'px',
      };
    },
    ...mapStores(useDndStore),
  }
}
</script>